import { CirclePacking } from '../../../models/circlePackingModel';

export const getSiblings: (circle: CirclePacking) => Array<CirclePacking> = (circle) => {
  if (!circle.ancestors) {
    return;
  }
  if (!circle.ancestors[circle.ancestors.length - 1]) {
    return;
  }

  if (!circle.ancestors[circle.ancestors.length - 1].children) {
    return;
  }

  return circle.ancestors[circle.ancestors.length - 1].children;
};
